import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { SplitSection } from '../layout/SplitSection';
import { cognocracyMethods, cognocracyPapers, type ProjectMaterial } from '../../data/initiatives';
import { fadeUp } from '../../utils/motion';

/** Papers and assessment methods behind Cognocracy, each with its current status. */
export function CognocracyMaterials() {
  return <SplitSection title="Papers and methods behind Cognocracy" intro={['The documents and assessment methods the initiative depends on.', 'None of the papers are published yet. Each is listed with its current status and will link to the full text once it is released.']} data-id="element-262" data-mp="2di1ksotpqi4i">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-x-10" data-id="element-263" data-mp="2sftx783yqqeh">
        <MaterialList heading="Papers" items={cognocracyPapers} data-id="element-264" data-mp="t3zqlprgp1c0" />
        <MaterialList heading="Assessment methods" items={cognocracyMethods} data-id="element-265" data-mp="y2b6ah4fu625" />
      </div>
    </SplitSection>;
}
type MaterialListProps = {
  heading: string;
  items: ProjectMaterial[];
};
function MaterialList({
  heading,
  items
}: MaterialListProps) {
  return <motion.div {...fadeUp} data-id="element-266" data-mp="2n8tt4ptq56cu">
      <h3 className="font-heading font-bold text-xl text-ink-dark mb-4" data-id="element-267" data-mp="2ib1r32zd83ux">{heading}</h3>
      <ul aria-label={heading} className="border-t border-line" data-id="element-268" data-mp="2i8yz4denk0nk">
        {items.map(item => <li key={item.title} className="border-b border-line" data-id="element-269" data-mp="2d9vzj8hfymmz">
            <a href={item.href} className="group flex items-start gap-4 py-6" data-id="element-270" data-mp="3ayefzjt00nre">
              <span className="flex-1" data-id="element-271" data-mp="360cvqvju6iec">
                <span className="flex flex-wrap items-center gap-x-3 gap-y-1.5" data-id="element-272" data-mp="361fnt6swaqvu">
                  <span className="font-heading font-bold text-lg text-ink-dark group-hover:text-navy transition-colors duration-150" data-id="element-273" data-mp="30zykl4mxusc3">
                    {item.title}
                  </span>
                  <span className="text-xs font-semibold text-navy border border-navy/20 bg-surface-muted rounded-md px-2.5 py-1 whitespace-nowrap" data-id="element-274" data-mp="1pn5vk1lj8hzq">
                    {item.status}
                  </span>
                </span>
                <span className="mt-1.5 block text-ink-muted leading-relaxed" data-id="element-275" data-mp="1mzvf899auphf">{item.summary}</span>
              </span>
              <ArrowRight size={18} aria-hidden="true" className="mt-1 shrink-0 text-teal transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-276" data-mp="1d3sg7c9qv6yp" />
            </a>
          </li>)}
      </ul>
    </motion.div>;
}